var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('button-component',_vm._b({attrs:{"variant":_vm.btnVariant,"title":_vm.$t(_vm.title)},on:{"btn-click":_vm.downloadHandler}},'button-component',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t(_vm.title)))]})],2):_c('LoaderComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }